import cn from 'clsx'
import s from './AboutSection.module.scss'
import { FC } from 'react'
import {
  FullHeightSection,
  Text,
  CustomImage,
  Container,
  Button,
} from '@components/ui'
import { CustomImageProps } from '@components/ui/CustomImage/CustomImage'
import { AboutpageAboutPageSectionsInner as AboutSectionType } from '@generated/model/models'

type AboutSectionProps = {
  data: AboutSectionType[]
  children?: any
}

const AboutSection: FC<AboutSectionProps> = ({ data, children }) => {
  return (
    <div className={s.root}>
      {data.map((section, index) => (
        <div className={s.section} key={`section_${index}`}>
          <Text
            html={section.title}
            className={s.title}
            variant="sectionHeading"
          />
          <Text
            html={section.detail}
            className={s.detail}
            variant="smallText"
          />

          {section.link && section.link_text && (
            <Button className={s.button} Component="a" href={section.link} target="_blank">
              {section.link_text}
            </Button>
          )}
        </div>
      ))}
    </div>
  )
}

export default AboutSection
